import { createReducer, on } from '@ngrx/store';

import * as agentsActions from '../actions/agents.actions';
import { AgentsState } from '../states/agents.state';

export const agentsReducer = createReducer(
    new AgentsState(),
    on(agentsActions.loadAgentsSuccess, (state, { agents }) => ({...state, agents}))
);